type Options = {
	dateFrom?: Date;
	dateTo?: Date;
	includeInactive?: boolean; // default false — dashboard agrega só viaturas ativas
};

// VehiclesMileageScreen reads its filters from localStorage on mount (not from URL).
// Writing this key before opening the page pre-populates the filters.
const FILTERS_CACHE_KEY = 'VEHICLESMILEAGEFILTER';

export const openMileageList = (opts: Options = {}) => {
	const filters = {
		pathStartDate: opts.dateFrom ?? undefined,
		pathEndDate: opts.dateTo ?? undefined,
		inactives: opts.includeInactive ?? false,
	};
	try {
		localStorage.setItem(FILTERS_CACHE_KEY, JSON.stringify(filters));
	} catch {
		// localStorage unavailable; open page anyway
	}
	window.open('/vehicles-mileage', '_blank');
};

export default openMileageList;
